import React from 'react';

export const useOverflowCell = <T extends HTMLElement>(
  deps: React.DependencyList = [],
) => {
  const ref = React.useRef<T>(null);
  const [isOverflowed, setIsOverflowed] = React.useState(false);

  React.useLayoutEffect(() => {
    const domElement = ref.current;

    setIsOverflowed(!!domElement && domElement.scrollWidth > domElement.clientWidth);
  }, deps);

  return { isOverflowed, ref };
};
